export const PAGINATION_LIMIT = 250;

//
// The following are the default sort by values to use.
//
export const DEFAULT_USER_LIST_SORT_BY_VALUE = "created,DESC";
